module.exports = __webpack_public_path__ + "static/media/3c531f65-5a4d-438a-bc3f-072410ad6ee1.f170caf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/3c531f65-5a4d-438a-bc3f-072410ad6ee1.png
// module id = 1455
// module chunks = 0